import React, { useState, useEffect } from 'react'

import { HttpService, API, Title, DateFormat } from '../../../config/react'
import DataTable from 'react-data-table-component'

function SystemService(props) {
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [ServiceLogs, setServiceLogs] = useState([])

  const columns = [
    // {
    //   name: 'Service Name',
    //   selector: (row) => row.service_name
    // },
    {
      name: 'Download CSV',
      selector: (row) =>
        row.download_csv ? (
          <i className="fa fa-check-circle"></i>
        ) : (
          <i className="fa fa-times-circle"></i>
        )
    },
    {
      name: 'Import in MySQL',
      selector: (row) =>
        row.insert_in_database ? (
          <i className="fa fa-check-circle"></i>
        ) : (
          <i className="fa fa-times-circle"></i>
        )
    },
    {
      name: 'Import in mongoDB',
      selector: (row) =>
        row.insert_in_mongodb ? (
          <i className="fa fa-check-circle"></i>
        ) : (
          <i className="fa fa-times-circle"></i>
        )
    },
    {
      name: 'Start Time',
      selector: (row) => <DateFormat value={row.start_time}></DateFormat>
    },
    {
      name: 'End Time',
      selector: (row) => <DateFormat value={row.end_time}></DateFormat>
    },
    {
      name: '',
      selector: (row) =>
        row.error_message !== null && row.error_message !== '' ? (
          <span
            data-toggle="tooltip"
            data-html="true"
            title={row.error_message}
          >
            <i className="fa fa-exclamation-triangle"></i>
          </span>
        ) : (
          ''
        )
    }
  ]

  const DefaultFilters = {
    page: 1,
    search: '',
    page_size: 10
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  const [totalRows, settotalRows] = useState()
  const [NivodaServiceStatus, setNivodaServiceStatus] = useState(false)
  const [VendorServiceStatus, setVendorServiceStatus] = useState(false)
  // const [NivodaSoldStatus, setNivodaSoldStatus] = useState(false)
  // const [VendorSoldStatus, setVendorSoldStatus] = useState(false)
  // const [diamondCount, setdiamondCount] = useState([])

  useEffect(() => {
    GetSettingOptions()
  }, [CustomFilters])

  // useEffect(() => {
  //   GetSoldStatus()
  // }, [])

  const GetSettingOptions = () => {
    const passData = {
      page: CustomFilters.page,
      search: CustomFilters.search,
      page_size: CustomFilters.page_size
    }
    HttpService.postApi(API.GetServiceLogs, passData).then((response) => {
      if (response.data.status === true) {
        const data = response.data.result[0]
        if (data.length > 0) {
          setServiceLogs(data)
          setForceUpdate(!isForceUpdate)
          settotalRows(data[0].total_count)
          if (!NivodaServiceStatus) {
            data.forEach((element) => {
              if (element.service_name === 'Nivoda Service' && element.end_time === null) {
                setNivodaServiceStatus(true)
              }
            })
          }
          if (!VendorServiceStatus) {
            data.forEach((element) => {
              if (element.service_name === 'Vendor Service' && element.end_time === null) {
                setVendorServiceStatus(true)
              }
            })
          }
        }
      }
    })
  }
  const handlePageChange = (e) => {
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCustomFilters({ ...CustomFilters, page_size: e })
  }

  // const StartService = (service) => {
  //   const passData = {
  //     service
  //   }
  //   HttpService.postApi(API.StartService, passData).then((response) => {
  //     if (response.data.status) {
  //       if (service === 'Nivoda') {
  //         setNivodaServiceStatus(true)
  //       } else {
  //         setVendorServiceStatus(true)
  //       }
  //       GetSettingOptions()
  //     }
  //   })
  // }

  // const StopService = (service) => {
  //   const passData = {
  //     service
  //   }
  //   HttpService.postApi(API.StopService, passData).then((response) => {
  //     if (response.data.status) {
  //       if (service === 'Nivoda') {
  //         setNivodaServiceStatus(false)
  //       } else {
  //         setVendorServiceStatus(false)
  //       }
  //       GetSettingOptions()
  //     }
  //   })
  // }

  // const GetSoldStatus = () => {
  //   const passData = {}
  //   HttpService.postApi(API.GetImportCounts, passData).then((response) => {
  //     if (response.data.result[0][0].vendor_count === '0') {
  //       setVendorSoldStatus(true)
  //     }
  //     if (response.data.result[0][0].nivoda_count === '0') {
  //       setNivodaSoldStatus(true)
  //     }
  //     const arr = []
  //     arr.push(response.data.result[0][0].nivoda_total_diamond)
  //     arr.push(response.data.result[0][0].pld_total_diamond)
  //     setdiamondCount(arr)
  //     setForceUpdate(!isForceUpdate)
  //   })
  // }

  // const SoldDiamonds = (service) => {
  //   const passData = {
  //     service
  //   }
  //   HttpService.postApi(API.SetSoldDiamond, passData).then((response) => {
  //     toast.success(Messages.DiamondSold)
  //   })
  // }

  // const subHeaderComponentMemo = React.useMemo(() => {
  //   return (
  //     <input
  //       type="text"
  //       title="Search For Title"
  //       className="form-control col-md-3"
  //       placeholder="Search"
  //       onChange={(e) => setCustomFilters({ ...CustomFilters, search: e.target.value })}
  //     />
  //   )
  // })

  return (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.SystemService} </h3>
      </div>
      {/* <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Service Name</th>
                      <th>Total Diamonds</th>
                      <th>Current Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Nivoda Diamond Import</td>
                      <td>{diamondCount[0]}</td>

                      <td>{NivodaServiceStatus ? 'Running' : 'Not Running'}</td>
                      <td>
                        <button
                          type="button"
                          onClick={(e) => StartService('Nivoda')}
                          className={
                            NivodaServiceStatus
                              ? 'btn btn-sm btn-primary d-none'
                              : 'btn btn-sm btn-primary'
                          }
                        >
                          Start Service
                        </button>
                        <button
                          type="button"
                          onClick={(e) => StopService('Nivoda')}
                          className={
                            NivodaServiceStatus
                              ? 'btn btn-sm btn-primary'
                              : 'btn btn-sm btn-primary d-none'
                          }
                        >
                          Stop Service
                        </button>
                        <button
                          type="button"
                          onClick={(e) => SoldDiamonds('Nivoda')}
                          className={
                            !NivodaServiceStatus && !NivodaSoldStatus
                              ? 'btn btn-sm btn-primary d-none'
                              : 'btn btn-sm btn-primary ml-2'
                          }
                        >
                          Sold Diamonds
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>PLD Diamond Import</td>
                      <td>{diamondCount[1]}</td>
                      <td>{VendorServiceStatus ? 'Running' : 'Not Running'}</td>
                      <td>
                        <button
                          type="button"
                          onClick={(e) => StartService('Vendor')}
                          className={
                            VendorServiceStatus
                              ? 'btn btn-sm btn-primary d-none'
                              : 'btn btn-sm btn-primary'
                          }
                        >
                          Start Service
                        </button>
                        <button
                          type="button"
                          onClick={(e) => StopService('Vendor')}
                          className={
                            VendorServiceStatus
                              ? 'btn btn-sm btn-primary'
                              : 'btn btn-sm btn-primary d-none'
                          }
                        >
                          Stop Service
                        </button>
                        <button
                          type="button"
                          onClick={(e) => SoldDiamonds('Vendor')}
                          className={
                            !VendorServiceStatus && !VendorSoldStatus
                              ? 'btn btn-sm btn-primary d-none'
                              : 'btn btn-sm btn-primary ml-2'
                          }
                        >
                          Sold Diamonds
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-header">
        <h3 className="page-title"> {Title.ServiceLogs} </h3>
      </div> */}
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={ServiceLogs}
                  // progressPending={loading}
                  pagination
                  persistTableHead={true}
                  paginationServer
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  subHeader
                  // subHeaderComponent={subHeaderComponentMemo}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SystemService
